import { ChangeDetectionStrategy, ChangeDetectorRef, Component, DestroyRef, inject, OnInit, signal } from '@angular/core';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { MatTableDataSource, MatTableModule } from '@angular/material/table';
import { ArrayResponse } from 'src/app/models/array_response.interface';
import { Skill } from 'src/app/models/skill.model';
import { ApiService } from 'src/app/services';

@Component({
  selector: 'app-upskilling-skills-tab',
  templateUrl: './upskilling-skills-tab.component.html',
  styleUrl: './upskilling-skills-tab.component.css',
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [MatTableModule],
})
export class UpskillingSkillsTabComponent implements OnInit {
  private readonly api_service = inject(ApiService);
  private readonly change_detector_ref = inject(ChangeDetectorRef);
  private readonly destroy_ref = inject(DestroyRef);

  readonly loading = signal(true);

  skills_data_source = new MatTableDataSource<Skill>([]);

  displayed_columns: string[] = ['name'];

  ngOnInit(): void {
    this.initSkills();
  }

  private initSkills(): void {
    this.loading.set(true);

    this.api_service
      .getSkills({ order_by: 'name:asc' })
      .pipe(takeUntilDestroyed(this.destroy_ref))
      .subscribe({
        next: (response: ArrayResponse<Skill>): void => {
          this.skills_data_source.data = response.data;
          this.loading.set(false);
          this.change_detector_ref.markForCheck();
        },
        error: (): void => {
          this.loading.set(false);
          this.change_detector_ref.markForCheck();
        },
      });
  }
}
